export const socketDisconnectedMessages = {
  en: {
    title: 'Connection to server lost',
    description: (
      <div>
        The IP Fabric server is not reachable.
        <br />
        This may be caused by local connectivity issues, problems with VPN, or
        by server reboot.
      </div>
    ),
    btnLabel: 'Refresh',
  },
};
